import React from "react";

const Button = ({ classes, btnText, onClick, icon, type = "button" }) => {
  return (
    <div className="w-full">
      <button
        type={type}
        className={`${classes}  flex justify-between items-center gap-2 overflow-hidden`}
        onClick={onClick}
      >
        <p className="text-center w-full">{btnText}</p>
        {icon && <span>{icon}</span>}
      </button>
    </div>
  );
};

export default Button;
